import { ApiResponse, post } from '@commblades/commblades';

interface IErrorBoundaryApiPayload {
    errorType: 'error' | 'warning',
    bladeName: string,
    errorMessage: string,
    stackTrack?: string,
}

type ErrorBoundaryApiT = {
    payload: IErrorBoundaryApiPayload
}

const { applicationRoot } = window.NetBank;

const errorBoundaryApi = ({
    payload,
}: ErrorBoundaryApiT): Promise<ApiResponse<void>> => post({ url: `${applicationRoot}/log/error`, payload });

export default errorBoundaryApi;
